import { SubPointType } from 'app/models/enums';

export class MapMatchSubPoint {
  public id: number;

  public subPoint: SubPointType;
  public osmId: number;
  public osmOffset: number;
  public lat: number;
  public lng: number;

  static copy(sp: MapMatchSubPoint): MapMatchSubPoint {
    return {
      id: sp.id,
      subPoint: sp.subPoint,
      osmId: sp.osmId,
      osmOffset: sp.osmOffset,
      lat: sp.lat,
      lng: sp.lng
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/models/mapmatchsubpoint.model.ts